import React, {useState} from "react";
import {Row} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import stores from "../../../store/stores";
import Filters from "./filters/Filters";
import {FiltersWrapper} from "../../_defaultComponents/FilterComponents/FiltersWrapper";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import moment from "moment";

const PoolCourierShifts = () => {
    const [recall, setRecall] = React.useState(false);
    const [filters, setFilters] = useState({
        poolId: new URLSearchParams(history?.location?.search)?.get("poolId") || undefined,
        date: moment().startOf("day"),
        courierId: undefined,
        courierShiftSelectionCount: "atLeastOneShiftThisPool",
        companyId: undefined,
        subCompanyId: undefined
    });

    const [courierShiftTableloading, courierShiftTableData] = useFetch({
        fetchFn: stores.poolShiftStore.getCourierShiftTable.bind(null, {
            poolId: filters?.poolId,
            date: filters?.date ? filters?.date.format("YYYY-MM-DD") : undefined,
            courierId: filters?.courierId || undefined
        }),
        initialCall: Boolean(filters?.poolId) && Boolean(filters?.date),
        dependencies: [filters?.poolId, filters?.date, filters?.courierId, recall],
        condition: Boolean(filters?.poolId) && Boolean(filters?.date)
    });

    return (
        <div>
            <FiltersWrapper gap={16} align="flex-end" marginBottom="16px">
                <Filters setFilters={setFilters} filters={filters} />
            </FiltersWrapper>
            {/*    
            <Row justify="end">
                <ActionButtons />
            </Row> 
            */}
            <Row>
                <ResponsiveDataTable
                    loading={courierShiftTableloading}
                    courierShiftTableDate={courierShiftTableData?.data || {}}
                    filters={filters}
                    setFilters={setFilters}
                    recall={() => setRecall(!recall)}
                />
            </Row>
        </div>
    );
};

export default PoolCourierShifts;
